import { render, staticRenderFns } from "./applyInsuranceMain.vue?vue&type=template&id=2b81bfef&scoped=true&"
import script from "./applyInsuranceMain.vue?vue&type=script&lang=js&"
export * from "./applyInsuranceMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b81bfef",
  null
  
)

export default component.exports